import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AccessibilityWidget from './components/AccessibilityWidget';
import Home from './pages/Home';
import Services from './pages/Services';
import Insurances from './pages/Insurances';
import Contact from './pages/Contact';

function App() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/insurances" element={<Insurances />} />
        <Route path="/order-exam" element={<Contact />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
      <AccessibilityWidget />
    </>
  );
}

export default App;
